(() => {
  const KEY = 'citroenair_wishlist_v1';

  const parse = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  };

  const save = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('citroenair:wishlist-updated', { detail: { items } }));
  };

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const moneyFreeQuantity = (value) => {
    const number = Number.parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : 1;
  };

  const getCurrentVariant = (root) => {
    const productJson = root.querySelector('[data-wishlist-product-json]');
    if (!productJson) return null;

    let product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return null; }

    const productForm = document.querySelector(`form[id^="product-form-${root.dataset.sectionId}"]`) ||
      root.closest('section')?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const variantId = productForm?.querySelector('[name="id"]')?.value || product.selected_or_first_available_variant?.id;
    const variant = product.variants?.find((item) => String(item.id) === String(variantId)) || product.selected_or_first_available_variant;
    if (!variant) return null;

    const quantityInput = productForm?.querySelector('[name="quantity"]');
    const quantity = moneyFreeQuantity(quantityInput?.value || 1);

    return {
  variantId: String(variant.id),
  productId: String(product.id),
  handle: product.handle,
  title: product.title,
  variantTitle: variant.title === 'Default Title' ? '' : variant.title,
  productType: product.product_type || '',
  brand: product.brand || '',
  material: product.material || '',
  color: product.color || '',
  finish: product.finish || '',
  url: `${window.Shopify?.routes?.root || '/'}products/${product.handle}?variant=${variant.id}`,
  image: variant.featured_image?.src || product.featured_image || '',
  sku: variant.sku || '',
  quantity
};
  };

  const updateBadges = () => {
    const total = parse().reduce((sum, item) => sum + moneyFreeQuantity(item.quantity), 0);
    document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
      badge.textContent = total;
      badge.hidden = total < 1;
      badge.setAttribute('aria-label', `${total}`);
    });
  };

  const addOrUpdate = (item) => {
    const items = parse();
    const existing = items.find((entry) => String(entry.variantId) === String(item.variantId));
    if (existing) {
      existing.quantity = moneyFreeQuantity(existing.quantity) + moneyFreeQuantity(item.quantity);
      Object.assign(existing, item, { quantity: existing.quantity });
    } else {
      items.push(item);
    }
    save(items);
    updateBadges();
  };

  const initButtons = () => {
    document.querySelectorAll('[data-wishlist-product]').forEach((root) => {
      const button = root.querySelector('[data-wishlist-add]');
      if (!button || button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';

      button.addEventListener('click', () => {
        const item = getCurrentVariant(root);
        if (!item) return;
        addOrUpdate(item);

        const original = button.querySelector('[data-label-default]');
        const success = button.querySelector('[data-label-success]');
        if (original && success) {
          original.hidden = true;
          success.hidden = false;
          window.setTimeout(() => {
            original.hidden = false;
            success.hidden = true;
          }, 1800);
        }
      });
    });
  };

  const refreshLocalizedItems = async (items) => {
  const currentRoot = window.Shopify?.routes?.root || '/';

  const refreshedItems = await Promise.all(
    items.map(async (item) => {
      if (!item.handle) return item;

      try {
        const localizedProductUrl =
          `${currentRoot}products/${encodeURIComponent(item.handle)}` +
          `?variant=${encodeURIComponent(item.variantId)}`;

        const response = await fetch(localizedProductUrl, {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html'
          }
        });

        if (!response.ok) {
          return item;
        }

        const html = await response.text();
        const documentParser = new DOMParser();
        const productDocument = documentParser.parseFromString(html, 'text/html');

        const productJsonElement = productDocument.querySelector(
          '[data-wishlist-product-json]'
        );

        if (!productJsonElement) {
          return item;
        }

        const localizedProduct = JSON.parse(productJsonElement.textContent);

        const localizedVariant =
          localizedProduct.variants?.find(
            (variant) =>
              String(variant.id) === String(item.variantId)
          ) ||
          localizedProduct.selected_or_first_available_variant;

        return {
          ...item,

          title: localizedProduct.title || item.title,

          variantTitle:
            localizedVariant?.title &&
            localizedVariant.title !== 'Default Title'
              ? localizedVariant.title
              : '',

          productType:
            localizedProduct.product_type || '',

          brand:
            localizedProduct.brand || '',

          material:
            localizedProduct.material || '',

          color:
            localizedProduct.color || '',

          finish:
            localizedProduct.finish || '',

          sku:
            localizedVariant?.sku || item.sku || '',

          image:
            localizedVariant?.featured_image?.src ||
            localizedProduct.featured_image ||
            item.image ||
            '',

          url:
            `${currentRoot}products/${localizedProduct.handle || item.handle}` +
            `?variant=${item.variantId}`
        };
      } catch (error) {
        console.warn(
          'Wishlist localization could not be refreshed:',
          item.handle,
          error
        );

        return item;
      }
    })
  );

  localStorage.setItem(KEY, JSON.stringify(refreshedItems));

  return refreshedItems;
};

  const initWishlistPage = () => {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    const list = root.querySelector('[data-wishlist-items]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const form = root.querySelector('[data-wishlist-form]');
    const hiddenSummary = root.querySelector('[data-wishlist-summary]');
    const hiddenJson = root.querySelector('[data-wishlist-json]');
    const printButton = root.querySelector('[data-wishlist-print]');
    const clearButton = root.querySelector('[data-wishlist-clear]');
    const titleInput = root.querySelector('[name="contact[Wishlist name]"]');
    const companyInput = root.querySelector('[name="contact[Company]"]');
    const printTitle = root.querySelector('[data-print-title]');
    const printCompany = root.querySelector('[data-print-company]');

    const labels = {
      remove: root.dataset.labelRemove,
      quantity: root.dataset.labelQuantity,
      sku: root.dataset.labelSku,
      barcode: root.dataset.labelBarcode,
      productNumber: root.dataset.labelProductNumber
    };

    const syncPrintFields = () => {
      if (printTitle) printTitle.textContent = titleInput?.value?.trim() || root.dataset.defaultTitle;
      if (printCompany) printCompany.textContent = companyInput?.value?.trim() || '';
    };

    const buildSummary = (items) => {
      const lines = items.map((item, index) => {
        return [
          `${index + 1}. ${item.title}${item.variantTitle ? ` - ${item.variantTitle}` : ''}`,
          `${labels.quantity}: ${moneyFreeQuantity(item.quantity)}`,
          item.sku ? `${labels.sku}: ${item.sku}` : '',
          item.barcode ? `${labels.barcode}: ${item.barcode}` : '',
          `${window.location.origin}${item.url}`
        ].filter(Boolean).join('\n');
      });
      if (hiddenSummary) hiddenSummary.value = lines.join('\n\n');
      if (hiddenJson) hiddenJson.value = JSON.stringify(items);
    };

    const render = async () => {
  let items = parse();

  items = await refreshLocalizedItems(items);
      list.innerHTML = '';
      empty.hidden = items.length > 0;
      list.hidden = items.length === 0;
      if (printButton) printButton.disabled = items.length === 0;

      items.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'wishlist-row';
        row.dataset.variantId = item.variantId;
        row.innerHTML = `
          <div class="wishlist-row__image">
            ${item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="${escapeHtml(item.title)}" width="120" height="120" loading="lazy">` : ''}
          </div>
          <div class="wishlist-row__product">
  <a href="${escapeHtml(item.url)}" class="wishlist-row__title">
    ${escapeHtml(item.title)}
  </a>

  ${item.variantTitle
    ? `<div>${escapeHtml(item.variantTitle)}</div>`
    : ''
  }

  ${item.sku
    ? `<div>SKU: ${escapeHtml(item.sku)}</div>`
    : ''
  }

  ${item.productType
    ? `<div>Product type: ${escapeHtml(item.productType)}</div>`
    : ''
  }

  ${item.brand
    ? `<div>Brand: ${escapeHtml(item.brand)}</div>`
    : ''
  }

  ${item.material
    ? `<div>Material: ${escapeHtml(item.material)}</div>`
    : ''
  }

  ${item.color
    ? `<div>Color: ${escapeHtml(item.color)}</div>`
    : ''
  }

  ${item.finish
    ? `<div>Finish: ${escapeHtml(item.finish)}</div>`
    : ''
  }
</div>
          <div class="wishlist-row__quantity">
            <label class="visually-hidden" for="WishlistQuantity-${escapeHtml(item.variantId)}">${escapeHtml(labels.quantity)}</label>
            <input id="WishlistQuantity-${escapeHtml(item.variantId)}" type="number" min="1" step="1" value="${moneyFreeQuantity(item.quantity)}" data-wishlist-quantity>
          </div>
          <button class="button button--tertiary wishlist-row__remove" type="button" data-wishlist-remove>${escapeHtml(labels.remove)}</button>
        `;
        list.appendChild(row);
      });
      buildSummary(items);
      syncPrintFields();
      updateBadges();
    };

    list.addEventListener('change', (event) => {
      const input = event.target.closest('[data-wishlist-quantity]');
      if (!input) return;
      const row = input.closest('[data-variant-id]');
      const items = parse();
      const item = items.find((entry) => String(entry.variantId) === String(row.dataset.variantId));
      if (item) item.quantity = moneyFreeQuantity(input.value);
      save(items);
      render();
    });

    list.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-remove]');
      if (!button) return;
      const row = button.closest('[data-variant-id]');
      save(parse().filter((item) => String(item.variantId) !== String(row.dataset.variantId)));
      render();
    });

    clearButton?.addEventListener('click', () => {
      save([]);
      render();
    });

    printButton?.addEventListener('click', () => {
      syncPrintFields();
      document.documentElement.classList.add('wishlist-printing');
      window.print();
      window.setTimeout(() => document.documentElement.classList.remove('wishlist-printing'), 500);
    });

    titleInput?.addEventListener('input', syncPrintFields);
    companyInput?.addEventListener('input', syncPrintFields);
    document.addEventListener('citroenair:wishlist-updated', render);
    render();
  };

  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    initWishlistPage();
    updateBadges();
  });

  document.addEventListener('shopify:section:load', () => {
    initButtons();
    initWishlistPage();
    updateBadges();
  });
})();
